import React from 'react';
import { Drawer, Button, Panel, Divider, Tag, Stack } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MdPerson } from 'react-icons/md';
import { useTranslation } from 'react-i18next';






interface DetailsDrawerViewProps {
  onClose: () => void;
  selectedRequest?: {
    idSender?: {
      firstname?: string;
      lastname?: string;
      registrationNumber?: string;
    };
    idReciever?: {
      firstname?: string;
      lastname?: string;
    };
    balance?: {
      WFHweekBalance?: Array<any>; // Assuming it's an array
    };
    _id?: {
      status?: string;
      type?: string;
    };
    operations?: Array<{
      createdAt?: string;
      date_debut?: string;
      date_fin?: string;
    }>;
  };
  [key: string]: any; // Allow additional props for the Drawer
}

const DetailsDrawerView = ({ onClose, selectedRequest, ...rest }: DetailsDrawerViewProps) => {
  const firstOperation = selectedRequest?.operations?.[0];
  const createdAt = firstOperation?.createdAt
    ? new Date(firstOperation.createdAt).toLocaleString()
    : 'N/A';

  const dateDebut = firstOperation?.date_debut ? new Date(firstOperation.date_debut) : null;
  const dateFin = firstOperation?.date_fin ? new Date(firstOperation.date_fin) : null;

  const daysRequested =
    dateDebut && dateFin
      ? Math.ceil((dateFin.getTime() - dateDebut.getTime()) / (1000 * 3600 * 24))
      : 'N/A';

  const durationRequested =
    dateDebut && dateFin
      ? `${dateDebut.toLocaleDateString()} - ${dateFin.toLocaleDateString()}`
      : 'N/A';

  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'accepted':
        return 'green';
      case 'pending':
        return 'orange';
      case 'rejected':
        return 'red';
      default:
        return 'gray';
    }
  };
  const { t } = useTranslation();



  return (
    <Drawer
      backdrop="static"
      size="sm"
      placement="right"
      onClose={onClose}
      {...rest}
      style={{
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px'
      }}
    >
      <Drawer.Header>
        <Drawer.Title>{t('Request Details')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="primary">
            {t('Close')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Panel bordered style={{ padding: '16px', borderRadius: '8px' }}>
          <Stack spacing={10}>
            <Icon as={MdPerson} style={{ fontSize: '25px', color: '#3498ff' }} />

            <h5 style={{ margin: 0, color: '#333' }}>
              {selectedRequest
                ? `${selectedRequest.idSender?.firstname} ${selectedRequest.idSender?.lastname}`
                : 'N/A'}
            </h5>
          </Stack>

          <Divider />

          {/* Request Details */}
          <div style={{ padding: '0 10px', lineHeight: 1.8 }}>
            {[
              {
                label: t('Status'),
                value: (
                  <Tag color={getStatusColor(selectedRequest?._id?.status)}>
                    {t(selectedRequest?._id?.status) || 'Unknown'}
                  </Tag>
                )
              },
              {
                label: t('Registration number'),
                value: selectedRequest?.idSender?.registrationNumber || 'N/A'
              },
              { label: t('Type'), value: selectedRequest?._id?.type || 'N/A' },
              { label: t('Period requested'), value: durationRequested },
              {
                label: t('Number of days requested'),
                value:
                  selectedRequest?.operations?.length > 0
                    ? selectedRequest?.operations[0]?.NB_Days > 1
                      ? `${selectedRequest?.operations[0]?.NB_Days} days`
                      : `${selectedRequest?.operations[0]?.NB_Days} day`
                    : ''
              },
              {
                label: t('Validator'),
                value: selectedRequest?.idReciever
                  ? `${selectedRequest.idReciever.firstname} ${selectedRequest.idReciever.lastname}`
                  : 'N/A'
              },
              { label: t('Created at'), value: createdAt }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '8px 0',
                  borderBottom: index < 6 ? '1px solid #f0f0f0' : 'none'
                }}
              >
                <strong>{item.label}:</strong>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        </Panel>
      </Drawer.Body>
    </Drawer>
  );
};

export default DetailsDrawerView;
